module.exports = __webpack_public_path__ + "static/media/ram_doc1.5dd96d09.jpg";